<div class="container">
  <div class="container__header">
    <div class="container__header__top">
      <h2>Permissions</h2>
      <div class="container__header__top__actions">
        <button mat-flat-button color="primary" (click)="openRoleModal()">Add Permission Group</button>
      </div>
    </div>
    <div class="container__header__bottom">
      <ng-container *ngIf="ui.isLoading">
        <mat-progress-bar mode="indeterminate" [class.visibility-hidden]="!ui.isLoading"></mat-progress-bar>
      </ng-container>
    </div>
  </div>
  <div class="container__content">
    <ng-container *ngIf="permissions$ | async as permissions; else firstLoad">
      <ng-container *ngIf="roles$ | async as roles; else firstLoad">
        <div class="container__content__roles">
          <app-settings-roles-list
            [roles]="roles"
            [selectedRole]="selectedRole"
            (roleSelected)="roleSelected($event)"
          ></app-settings-roles-list>
        </div>
        <div class="container__content__permissions">
          <app-settings-permissions-list
            [role]="selectedRole"
            [readOnly]="!selectedRole.account_id"
            [permissionsRoles]="selectedRole.permissions_roles"
            (permissionsSaved)="permissionsSaved($event)"
            (editRoleClicked)="editRoleClicked()"
            (removeRoleClicked)="removeRoleClicked()"
          ></app-settings-permissions-list>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #firstLoad>
      <div class="ph-item">
        <div class="ph-col-12">
          <div class="ph-row">
            <div class="ph-col-6 big"></div>
            <div class="ph-col-2 empty big"></div>
            <div class="ph-col-4 big"></div>
            <div class="ph-col-4"></div>
            <div class="ph-col-4 empty"></div>
            <div class="ph-col-4 big"></div>
          </div>
        </div>
        <div class="ph-col-4">
          <div class="ph-row">
            <div class="ph-col-12 big"></div>
            <ng-container *ngFor="let item of [].constructor(20)">
              <div class="ph-col-8"></div>
              <div class="ph-col-4 empty"></div>
            </ng-container>
          </div>
        </div>
        <div class="ph-col-8">
          <div class="ph-row">
            <ng-container *ngFor="let item of [].constructor(10)">
              <div class="ph-col-6 big"></div>
              <div class="ph-col-4 empty big"></div>
              <div class="ph-col-2 big"></div>
              <div class="ph-col-4"></div>
              <div class="ph-col-6 empty"></div>
              <div class="ph-col-2"></div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
